"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.PreviewTextContext = react_1.createContext({});
exports.ArrayContext = react_1.createContext({});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-shared-components/lib/context.js
// module id = 549
// module chunks = 0